import isNotEmpty from './isNotEmpty';

export default function (...strings: (string | undefined | null)[]) {
  return strings
    .filter(isNotEmpty)
    .filter((s) => s.length > 0)
    .join(' ');
}
